import img from '../../../../../assets/images/textEditorToolBarIcons/Italic.svg';

export const ItalicButton = img;
